// THE LEVEL, BIG, AFTER A SCAN (his rule, 20 Oct): "Level D — 4th from bottom", so a scan of the wrong level
// is caught straight away. Only rack positions carry one (rack_level from the server); anything else shows nothing.
export const RackLevel = ({ level, testid = "rack-level", compact = false }) => {
  if (!level) return null;
  return (
    <div data-testid={testid} className="flex items-center gap-4 rounded-xl border-2 border-[#1F1F1F] bg-white px-4 py-2 mt-3">
      <div data-testid={`${testid}-letter`}
        className={`font-display font-black leading-none text-[#1F1F1F] ${compact ? "text-6xl" : "text-[88px]"}`}>
        {level.letter}
      </div>
      <div className="min-w-0">
        <div data-testid={`${testid}-words`} className={`font-black text-slate-900 leading-tight ${compact ? "text-lg" : "text-2xl"}`}>
          {level.words}
        </div>
        <div className="text-sm text-slate-600">Bay {level.bay} · <span className="font-mono">{level.code}</span></div>
      </div>
    </div>
  );
};
